// extracted by mini-css-extract-plugin
export default {"content":"FormattedJSON_content__H0sQ+"};